import { isGroupTableSelected } from 'owa-group-utils';
import { isGroupsEnabled } from 'owa-account-capabilities/lib/isGroupsEnabled';
import { ComposeViewState } from 'owa-mail-compose-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function shouldAddinsPopulate(viewState: ComposeViewState): boolean {
    if (viewState.protectionViewState?.IRMData?.RmsTemplateId) {
        return false;
    } else if (isGroupsEnabled() && isGroupTableSelected()) {
        return false;
    }
    return isFeatureEnabled('rp-addins');
}
